import React from 'react';
import Labeled from '../labeled/labeled';
import Input from './input.component';

interface Props {
  readonly labelText?: string;
  readonly tooltipText?: string;
  readonly tooltipId?: string;
  readonly type?: string;
  readonly disabled?: boolean;
  readonly placeholder?: string;
  readonly defaultValue?: string;
  readonly value?: string;
  readonly maxLength?: number;
  readonly min?: number;
  readonly max?: number;
  readonly step?: number;
  readonly onChange?: (value: string) => void;
  readonly onFocusChange?: (focus: boolean, value: string) => void;
  readonly onEnter?: () => void;
  readonly doClearOnEnter?: boolean;
}

const LabeledInput = ({
  labelText,
  tooltipText,
  tooltipId,
  type,
  disabled,
  placeholder,
  defaultValue,
  value,
  maxLength,
  min,
  max,
  step,
  onChange,
  onFocusChange,
  onEnter,
  doClearOnEnter,
}: Props): React.JSX.Element => (
  <Labeled labelText={labelText} tooltipText={tooltipText} tooltipId={tooltipId}>
    <Input
      type={type}
      disabled={disabled}
      placeholder={placeholder}
      defaultValue={defaultValue}
      value={value}
      maxLength={maxLength}
      min={min}
      max={max}
      step={step}
      onChange={onChange}
      onFocusChange={onFocusChange}
      onEnter={onEnter}
      doClearOnEnter={doClearOnEnter}
    />
  </Labeled>
);

export default LabeledInput;
